import type {InjectionKey} from 'vue'

export interface SimmerringWidgetConfig {
  /** Region code, e.g. 'EU', 'NA' */
  region: string
  /** Base URL for the Simmerring Selector API, e.g. 'https://apim-enext-stg.azure-api.net' */
  apiBaseUrl: string
  /** API key for the Simmerring Selector API */
  simmerringApiKey: string
  /** Base URL for static assets and product links, e.g. 'https://catalog.fst.com' */
  assetBaseUrl: string
  /** Derived at mount time: assetBaseUrl/{region}/{locale} — do not set manually */
  productLinkBase: string
  /** Initial unit: 'inch' or 'mm'. Defaults to 'mm' */
  initialUnit?: 'inch' | 'mm'
  /** Contact email shown in the widget */
  contactMail?: string
  /** Company number for identification */
  companyNo?: string
  /** Language code for API requests (derived from build-time locale) */
  language: string
}

export const WIDGET_CONFIG: InjectionKey<SimmerringWidgetConfig> = Symbol('widget-config')
export const IS_WIDGET: InjectionKey<boolean> = Symbol('is-widget')
